module.exports = __webpack_public_path__ + "img/Picture.d23e0d8f.svg";